import { Box, Card } from '@qga/roo-ui/components';
import { ContentHeading } from 'components/Typography';
import { FormattedCalendarDate } from 'components/Formatters';
import { GroupItems, Item, ItemGroup } from 'components/ReviewCard';
import CancellationPolicyMessageBoard from '../../CancellationPolicyMessageBoard';

const NewStayDates = ({ newCheckIn, newCheckOut, openCancellationPolicyModal, ...rest }) => (
  <Box {...rest}>
    <ContentHeading mb={2} fontSize={['xl', '2xl']}>
      New stay dates
    </ContentHeading>
    <CancellationPolicyMessageBoard onClickCancellationPolicy={openCancellationPolicyModal} />
    <Card p={0} mt={3}>
      <ItemGroup>
        <GroupItems pt={0}>
          <Item labelItem="Check-in" valueItem={<FormattedCalendarDate date={newCheckIn} />} boldValue />
          <Item labelItem="Check-out" valueItem={<FormattedCalendarDate date={newCheckOut} />} boldValue />
        </GroupItems>
      </ItemGroup>
    </Card>
  </Box>
);

export default NewStayDates;
